export enum TransactionType {
    Account = 'account',
    Security = 'security',
}
